import React, { createContext, PropsWithChildren, useContext } from "react";

export interface IConfig {
  URL_DISCREPANCIES_GOOGLE: string;
  URL_DISCREPANCIES_TRIPADVISOR: string;
  URL_DISCREPANCIES_TRIVAGO: string;
  URL_PROPERTY_ARI_FIRST: string;
  URL_PROPERTY_ARI_SECOND: string;
  keycloakRealm: string;
  keycloakUrl: string;
  keycloakClientId: string;
  engineBaseUrl: string;
  grpcApiEndpoint: string;
  queryExecutorApiEndpoint: string;
  engineApiEndpoint: string;
  apiEndpoint: string;
  middlewareEndpoint: string;
  headerColor: string;
  mediaMaxSizeMB: number;
  mediaMaxFiles: number;
  mediaMinWidth: number;
  keycloakLoyaltyUrl: string;
  backofficeProtocol: string;
  freshdeskSSOUrl: string;
  loyaltyApiEndpoint: string;
  reservationEventsApiEndpoint: string;
  ariServiceUrl: string;
  metaSearchApiGateway: string;
  userManagerUrl: string;
  bookingStatUrl: string;
  dashboardUrl: string;
  myMotorUrl: string;
  notificationsWitbookingUrl: string;
  paymentsApiEndpoint: string;
  replicatePropertyEndpoint: string;
  googleAPiKey: string;
  waitingListApiEndpoint: string;
  eventsApiEndpoint: string;
  sellingApiEndpoint: string;
  guestAssistantApiEndpoint: string;
  metaAppId: string;
  whatsAppSignupConfigId: string;
  whatsAppSignupSolutionId: string;
  storeOrchestratorApiEndpoint: string;
  onlineStoreUrl: string;
  backofficeAssistantApiEndpoint: string;
}

function loadConfigFromWindow(): IConfig {
  if (!window.CONFIG) {
    throw new Error("No configuration specified. This is a deployment error.");
  }
  return window.CONFIG;
}

export function loadConfig() {
  //We only load config from window.CONFIG. This is loaded in index.html and put in place by proxy/container
  return loadConfigFromWindow();
}

const ConfigContext = createContext<IConfig>({
  URL_PROPERTY_ARI_FIRST: "",
  URL_PROPERTY_ARI_SECOND: "",
  URL_DISCREPANCIES_GOOGLE: "",
  URL_DISCREPANCIES_TRIPADVISOR: "",
  URL_DISCREPANCIES_TRIVAGO: "",
  keycloakUrl: "",
  keycloakClientId: "",
  keycloakRealm: "",
  engineBaseUrl: "",
  grpcApiEndpoint: "",
  queryExecutorApiEndpoint: "",
  engineApiEndpoint: "",
  apiEndpoint: "",
  middlewareEndpoint: "",
  headerColor: "#6b1345",
  mediaMaxSizeMB: 10,
  mediaMaxFiles: 10,
  mediaMinWidth: 768,
  keycloakLoyaltyUrl: "",
  backofficeProtocol: "",
  freshdeskSSOUrl: "",
  loyaltyApiEndpoint: "",
  reservationEventsApiEndpoint: "",
  ariServiceUrl: "",
  metaSearchApiGateway: "",
  userManagerUrl: "",
  bookingStatUrl: "",
  dashboardUrl: "",
  myMotorUrl: "",
  notificationsWitbookingUrl: "",
  paymentsApiEndpoint: "",
  replicatePropertyEndpoint: "",
  googleAPiKey: "",
  waitingListApiEndpoint: "",
  eventsApiEndpoint: "",
  sellingApiEndpoint: "",
  guestAssistantApiEndpoint: "",
  metaAppId: "",
  whatsAppSignupConfigId: "",
  whatsAppSignupSolutionId: "",
  storeOrchestratorApiEndpoint: "",
  onlineStoreUrl: "",
  backofficeAssistantApiEndpoint: "",
});

export function ConfigProvider(props: PropsWithChildren<{ value: IConfig }>) {
  return <ConfigContext.Provider value={props.value}>{props.children}</ConfigContext.Provider>;
}

export function useConfig(): IConfig {
  return useContext(ConfigContext);
}

export function getLanguageFromFullLocale(locale: string): string {
  const pieces = locale.split("-");
  return pieces[0];
}

//This one is for compatibility with witadmin.
export function withConfig<P = {}>(
  Component: React.ComponentType<P & { property: IConfig }>
): React.ComponentType<P> {
  return (props: P) => {
    const data = useConfig();
    return <Component property={data} {...props} />;
  };
}
